import { useEffect } from 'react'
import { loadCurrentUser } from '../api/auth'
import { useAuthStore } from '../authStore'

export function useCurrentUser() {
  const status = useAuthStore((s) => s.status)
  const setUser = useAuthStore((s) => s.setUser)

  useEffect(() => {
    if (status !== 'unknown') return
    let cancelled = false
    loadCurrentUser().then((u) => {
      if (cancelled) return
      setUser(u)
    })
    return () => {
      cancelled = true
    }
  }, [status, setUser])

  return status
}
